import { EmergencyContactItemDto } from '@/api/generated';
import { EmergencyContactsSearchFormModel } from '@/views/emergencyContacts/list/components/table/model/EmergencyContactsSearchForm.model.ts';

export type EmergencyContactsListTranslation = {
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: Record<keyof Omit<EmergencyContactItemDto, 'id'>, string>;
    details: {
      createdAt: string;
      description: string;
      noDescription: string;
      open: string;
    };
    head: Record<keyof EmergencyContactsSearchFormModel, string>;
    quickFilters: {
      inactive: string;
    };
    row: {
      statusOptions: Record<string, string>;
    };
  };
};

export const emergencyContactsListTranslation: EmergencyContactsListTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: {
      category: 'Kategoria',
      email: 'Email',
      name: 'Nazwa',
      phoneNumber: 'Numer telefonu',
      status: 'Status',
    },
    details: {
      createdAt: 'Dodany',
      description: 'Opis',
      noDescription: 'Brak opisu',
      open: 'Otwórz',
    },
    head: {
      categories: 'Kategorie',
      fullTextSearchInput: 'Szukaj',
      status: 'Status',
    },
    quickFilters: {
      inactive: 'Nieaktywne',
    },
    row: {
      statusOptions: {
        Active: 'Aktywny',
        Inactive: 'Nieaktywny',
      },
    },
  },
};
